import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Sheet } from '@node-space/ui-components'
import type { ConfirmBusinessCustomerV2Data } from '../helpers/types'
import { AddCustomerConfirmDetails } from './AddCustomerConfirmDetails'
import { AddCustomerForm } from './AddCustomerForm'

export interface AddCustomerProps {
  isOpen: boolean
  onClose: () => void
  onCustomerAdded: () => void
}

export const AddCustomer = ({ isOpen, onClose, onCustomerAdded }: AddCustomerProps) => {
  const { t } = useTranslation()
  const [isConfirmView, setIsConfirmView] = useState(false)
  const [confirmData, setConfirmData] = useState<ConfirmBusinessCustomerV2Data>()

  const onConfirmDetails = (data: ConfirmBusinessCustomerV2Data) => {
    setConfirmData(data)
    setIsConfirmView(true)
  }

  const onBack = () => {
    if (isConfirmView) {
      setIsConfirmView(false)
    } else {
      onClose()
    }
  }

  const reset = () => {
    setConfirmData(undefined)
    setIsConfirmView(false)
  }

  const onCancel = () => {
    reset()
    onClose()
  }

  const onSuccess = () => {
    reset()
    onClose()
    onCustomerAdded()
  }

  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      header={t(isConfirmView ? 'customers.confirmDetails' : 'customers.newBusinessCustomer')}
      onBack={onBack}
    >
      <Box width="full" paddingY={24}>
        {isConfirmView && confirmData ? (
          <AddCustomerConfirmDetails
            confirmData={confirmData}
            onSuccess={onSuccess}
            onCancel={onCancel}
          />
        ) : (
          <AddCustomerForm
            defaultValues={confirmData?.formData}
            onConfirm={onConfirmDetails}
            onCancel={onCancel}
          />
        )}
      </Box>
    </Sheet>
  )
}
